import { RootState } from '../../store/rootReducer';

export const NotificationSelector = (state: RootState) => state.notification;
